module.exports = __webpack_public_path__ + "img/knifeInGroinText1.d9d0cbd2.png";